module.exports = __webpack_public_path__ + "img/kapian.b41a5c8f.png";